import { useCallback, useEffect, useRef } from 'react';

import useLogin from 'src/hooks/useLogin';
import { ControlledPromise } from 'src/utils/controlled-promise';

import { LoginUserModalInitPromise, OrderedModalHookType } from './types';

const withLoginUserModalPromise = (useOrderedModalHook: OrderedModalHookType) => {
  return () => {
    const modalPropsPromiseRef = useRef<LoginUserModalInitPromise | null>(null);
    const { isLogin } = useLogin();

    const initializeModalPromise = useCallback(() => {
      const modalPropsPromise: LoginUserModalInitPromise = new ControlledPromise();
      modalPropsPromiseRef.current = modalPropsPromise;
      return modalPropsPromise;
    }, []);

    useEffect(() => {
      if (!isLogin) {
        modalPropsPromiseRef.current = null;
      }
    }, [isLogin]);

    useOrderedModalHook(modalPropsPromiseRef.current);

    return {
      initializeModalPromise,
    };
  };
};

export default withLoginUserModalPromise;
